module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.9feb011.woff2";